import * as types from './types';
import { fetchGeneric } from 'State/generic/actions';

export const getReimbursementRates = () => {
  return dispatch => {
    dispatch(
      fetchGeneric(
        types.REIMBURSEMENT_RATES_GET_REIMBURSEMENT_RATES,
        types.REIMBURSEMENT_RATES_FETCHING,
        types.REIMBURSEMENT_RATES_FETCH_ERROR,
        `ReimbursementRate`
      )
    );
  };
};
export const clearFormData = () => {
  return dispatch => {
    dispatch({ type: types.REIMBURSEMENT_RATE_CLEAR_FORM_DATA });
  };
};

export const clearError = () => {
  return dispatch => {
    dispatch({ type: types.REIMBURSEMENT_RATES_CLEAR_FETCH_ERROR });
  };
};

export const setFormDataById = id => {
  return (dispatch, getState) => {
    const rates = getState().ReimbursementRatesState.rates.reimbursementRates;
    const value = rates.find(x => x.Id === id);

    dispatch({
      type: types.REIMBURSEMENT_RATE_SET_FORM_DATA_BY_ID,
      payload: value,
    });
  };
};

export const setReimbursementRate = newRemibursementRateId => {
  return dispatch => {
    dispatch({
      type: types.REIMBURSEMENT_RATES_SET_REIMBURSMENT_RATE,
      payload: newRemibursementRateId,
    });
  };
};

export const writeReimbursementRate = fieldModel => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      await MPWWebApi.postGenericInsertUpdate('ReimbursementRate', fieldModel);
      const response = await MPWWebApi.getGeneric('ReimbursementRate');

      dispatch({
        type: types.REIMBURSEMENT_RATES_GET_REIMBURSEMENT_RATES,
        payload: { data: response.data.Data },
      });

      const obj = response.data.Data.find(
        x => x.Description === fieldModel.Description
      );

      if (obj) {
        dispatch({
          type: types.REIMBURSEMENT_RATE_SETSUCCESS,
          payload: true,
        });
        dispatch({
          type: types.REIMBURSEMENT_RATE_SET_FORM_DATA_BY_ID,
          payload: obj,
        });
        dispatch({
          type: types.REIMBURSEMENT_RATES_SET_REIMBURSMENT_RATE,
          payload: obj.Id,
        });
      }
    } catch (ex) {
      dispatch({
        type: types.REIMBURSEMENT_RATES_FETCH_ERROR,
        payload: ex.response.data.Data.Message,
      });
    }
  };
};

export const setSuccess = value => {
  return dispatch => {
    dispatch({ type: types.REIMBURSEMENT_RATE_SETSUCCESS, payload: value });
  };
};

export const setCancelChange = value => {
  return dispatch => {
    dispatch({ type: types.REIMBURSEMENT_RATE_CANCEL_CHANGE, payload: value });
  };
};



// WEBPACK FOOTER //
// ./src/pages/reimbursementrates/state/rates/actions.js